import {
    GET_COUNTRY,
    GET_COUNTRY_SUCCESS,
    ADD_COUNTRY,
    ADD_COUNTRY_SUCCESS,
    UPDATE_COUNTRY,
    UPDATE_COUNTRY_SUCCESS,
    DELETE_COUNTRY,
    DELETE_COUNTRY_SUCCESS,
    COUNTRY_API_ERROR
  
  } from "./actionTypes"
  
  
  
  
  export const getCountryList = () => ({
    type: GET_COUNTRY,
  })
  
  export const getCountryListSuccess = record => ({
    type: GET_COUNTRY_SUCCESS,
    payload: record,
  })
  
  export const addCountry = record => ({
    type: ADD_COUNTRY,
    payload: record,
  })
  
  export const addCountrySuccess = record => ({
    type: ADD_COUNTRY_SUCCESS,
    payload: record,
  })
  
  
  export const updateCountry = record => ({
    type: UPDATE_COUNTRY,
    payload: record,
  })
  
  export const updateCountrySuccess = record => ({
    type: UPDATE_COUNTRY_SUCCESS,
    payload: record,
  })
  
  
  export const deleteCountry = guid => ({
    type: DELETE_COUNTRY,
    payload: guid,
  })
  
  export const deleteCountrySuccess = guid => ({
    type: DELETE_COUNTRY_SUCCESS,
    payload: guid,
  })
  
  export const apiCountryApiError = error => {
    return {
      type: COUNTRY_API_ERROR,
      payload: error,
    }
  }
  
  